import abdullahiMaikanoImage from 'assets/images/advisors/abdullahi_maikano.png';
import dennisVaccoImage from 'assets/images/advisors/dennis_vacco.png';
import drJanuszFajkowskiImage from 'assets/images/advisors/dr_janusz_fajkowski.png';
import halimeOzenErbasImage from 'assets/images/advisors/halime_ozen_erbas.png';
import loriProcherImage from 'assets/images/advisors/lori_procher.png';
import michaelLustigImage from 'assets/images/advisors/michael_lustig.png';
import michaelRossettiImage from 'assets/images/advisors/michael_rossetti.png';
import paulCiminelliImage from 'assets/images/advisors/paul_ciminelli.png';
import rufatNovruzovImage from 'assets/images/advisors/rufat_novruzov.png';
import stephenSchuelerImage from 'assets/images/advisors/stephen_schueler.png';
import tomWileyImage from 'assets/images/advisors/tom_wiley.png';
import tsviKanTorImage from 'assets/images/advisors/tsvi_kan_tor.png';
import yoelRazvozovImage from 'assets/images/advisors/yoel_razvozov.png';

const config = [
  {
    name: 'Dennis Vacco',
    location: 'New York, USA',
    image: dennisVaccoImage
  },
  {
    name: 'Lori Procher',
    location: 'Ontario, Canada',
    image: loriProcherImage
  },
  {
    name: 'Tsvi Kan Tor',
    location: 'Ramat Gan, Israel',
    image: tsviKanTorImage
  },

  {
    name: 'Yoel Razvozov',
    location: 'Israel',
    image: yoelRazvozovImage
  },
  {
    name: 'Abdullahi Maikano',
    location: 'Abuja, Nigeria',
    image: abdullahiMaikanoImage
  },
  {
    name: 'Tom Wiley',
    location: 'New York, USA',
    image: tomWileyImage
  },
  {
    name: 'Halime Özen Erbaş',
    location: 'Antalya, Turkey',
    image: halimeOzenErbasImage
  },
  {
    name: 'Michael Lustig',
    location: 'New York, USA',
    image: michaelLustigImage
  },
  {
    name: 'Dr. Janusz Fajkowski',
    location: 'Warsaw, Poland',
    image: drJanuszFajkowskiImage
  },
  {
    name: 'Rufat Novruzov',
    location: 'Baku, Azerbaijan',
    image: rufatNovruzovImage
  },
  {
    name: 'Michael Rossetti',
    location: 'Washington D.C, USA',
    image: michaelRossettiImage
  },
  {
    name: 'Stephen Schueler',
    location: 'Denmark',
    image: stephenSchuelerImage
  },
  {
    name: 'Paul Ciminelli',
    location: 'New York, USA',
    image: paulCiminelliImage
  }
];

export default config;
